// 공통 버튼 스타일 유틸리티
export const useButtonStyles = () => {
  return {
    // 작은 버튼 (테이블 내 액션 버튼용)
    btnSmall: {
      blue: "inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors",
      green: "inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-white bg-green-600 rounded-md hover:bg-green-700 transition-colors",
      red: "inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors",
      yellow: "inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-white bg-yellow-600 rounded-md hover:bg-yellow-700 transition-colors",
      gray: "inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-gray-100 bg-gray-600 rounded-md hover:bg-gray-700 transition-colors",
    },
    // 중간 버튼 (모달 내 액션 버튼용)
    btnMedium: {
      blue: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors",
      green: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors",
      red: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors",
      yellow: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-yellow-600 rounded-lg hover:bg-yellow-700 transition-colors",
      slate: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-slate-900 rounded-lg hover:bg-slate-800 transition-colors",
    },
    // 보조 버튼 (취소/닫기용)
    btnSecondary: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors",
    // 검색 버튼
    btnSearch: "inline-flex items-center gap-2 px-4 py-2 bg-slate-900 text-white text-sm font-medium rounded-lg hover:bg-slate-800 transition-colors h-[38px]",
    // 페이지네이션 버튼
    btnPagination: "px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors",
    // 새로고침 버튼
    btnRefresh: "inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors",
  };
};

